// Bildirim akışı için saf, immutable durum geçişleri. İyimser güncellemede
// (mark-read/mark-all) React Query cache'i BU fonksiyonlarla türetilir; ayrı
// tutulmaları deterministik birim testini kolaylaştırır (mutation YOK — hep yeni nesne).

import type { NotificationFeed } from './types';

/** Tek bildirimi okundu yapar ve okunmamışsa rozeti 1 azaltır (zaten okunmuşsa no-op). */
export function markOneRead(feed: NotificationFeed, id: string): NotificationFeed {
  let flippedToRead = false;
  const readAt = new Date().toISOString();
  const items = feed.items.map((n) => {
    if (n.id !== id || n.isRead) return n;
    flippedToRead = true;
    return { ...n, isRead: true, readAt };
  });
  return {
    items,
    unreadCount: Math.max(0, feed.unreadCount - (flippedToRead ? 1 : 0)),
  };
}

/** Tüm bildirimleri okundu yapar ve rozeti 0'a indirir. */
export function markAllRead(feed: NotificationFeed): NotificationFeed {
  const readAt = new Date().toISOString();
  return {
    items: feed.items.map((n) => (n.isRead ? n : { ...n, isRead: true, readAt })),
    unreadCount: 0,
  };
}
